import { render, staticRenderFns } from "./TagBox.vue?vue&type=template&id=5039b4ec"
import script from "./TagBox.vue?vue&type=script&lang=js"
export * from "./TagBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports